import React from "react"
import { addOrderToBasket } from "../../../services/api/mergerApi"
import { notification } from "antd"
import _ from 'lodash'

export default async function (barcode, fac = '1C', containerRef) {
    notification.destroy()
    try {
        const { data: response } = await addOrderToBasket(barcode, fac)

        const { success, data, error } = response
        const { packed_methods = [], items = [] } = data || {}
        const listItemSpecial = items.filter(item => ["BRAND_KIT", "THANK_CARD"].includes(item.product_type)) || []
        const listItemNormal = items.filter(item => !["BRAND_KIT", "THANK_CARD"].includes(item.product_type)) || []
        const isUnShowNotification = !!listItemNormal.length && listItemNormal.every(i => _.get(i, 'originProduct.meta.packed_method', '') === _.get(listItemNormal[0], 'originProduct.meta.packed_method')) &&
            !!listItemSpecial.length
        const isShowNotification = packed_methods.length > 1 && !isUnShowNotification
        isShowNotification === true && notification.open({
            message: <div className='align-items-center d-flex'>
                <i className="text-warning mr-4 fa fa-exclamation-circle" aria-hidden="true" style={{ fontSize: 70 }} />
                <span className='font-weight-bold'>{`Trong giỏ có 2 kiểu đóng gói khác nhau, cần lưu ý gộp đủ item trong đơn.`}</span>
            </div>,
            duration: 0,
            icon: null,
            placement: 'topRight',
            style: {
                overflowY: 'unset',
                borderRadius: 20,
                maxHeight: 'unset',
            },
            getContainer: () => containerRef.current,
        })
        if (!success) {
            throw new Error(error)
        }

        return data
    } catch (e) {
        throw new Error(e)
    }
}
